import { mapActions } from "vuex";
import _ from "lodash";
const MOCK_TYPES_FILTER = [
  {
    nome: "N° Apólice",
    id: "numero_apolice"
  },
  {
    nome: "N° Endosso",
    id: "numero"
  },
  {
    nome: "Tipo Endosso",
    id: "tipo_endossos"
  },
  {
    nome: "Número Interno Cliente",
    id: "numero_controle_interno"
  },
  {
    nome: "Número do Processo Judicial",
    id: "numero_processo"
  },
  {
    nome: "Início de Vigência",
    id: "data_inicio_vigencia"
  },
  {
    nome: "Término de Vigência",
    id: "data_fim_vigencia"
  },
  {
    nome: "Seguradora",
    id: "seguradoras"
  },
  {
    nome: "Tribunal",
    id: "tribunal_id"
  },
  {
    nome: "Grupo Econômico",
    id: "grupo_economico_id"
  },
  {
    nome: "Modalidade",
    id: "modalidades"
  },
  {
    nome: "SubModalidade",
    id: "submodalidades"
  },
  {
    nome: "Reclamante/Segurado",
    id: "segurado_id"
  },
  {
    nome: "Status",
    id: "situacao"
  }
];
const MOCK_AUTOCOMPLETE_FILTER = [
  "Tribunal",
  "Grupo Econômico",
  "Reclamante/Segurado",
  "Número Solicitação"
];
const MOCK_NORMAL_FILTER = [
  "N° Apólice",
  "N° Endosso",
  "Número Interno Cliente",
  "Número do Processo Judicial"
];

const MOCK_INTERVAL_DATE_FILTER = ["Início de Vigência", "Término de Vigência"];
const MOCK_SELECT_FILTER = [
  "Seguradora",
  "Modalidade",
  "SubModalidade",
  "Tipo Endosso",
  "Status"
];
const MOCK_REQUEST_SELECT_FILTER = [
  "requestInsuranceCompanyQuotation",
  "requestModalityQuotation",
  "requestSubModalityQuotation",
  "requestTypeEndorsementQuotation",
  "requestStatusEndorsementQuotation"
];
const MOCK_REQUEST_AUTOCOMPLETE_FILTER = [
  "requestTakerQuotation",
  "requestCourtQuotation",
  "requestEconomicGroupQuotation",
  "requestInsuredQuotation",
  "requestNumberQuotation"
];
export default {
  data: () => ({
    timeout: null,
    listTypesFilterRequestEndorsement: MOCK_TYPES_FILTER,
    MOCK_AUTOCOMPLETE_FILTER,
    MOCK_NORMAL_FILTER,
    MOCK_INTERVAL_DATE_FILTER,
    MOCK_SELECT_FILTER
  }),
  computed: {
    listTypesFilterEndorsement() {
      return _.slice(MOCK_TYPES_FILTER, 0, -1);
    }
  },
  methods: {
    ...mapActions("quotation", [
      "requestCourtQuotation",
      "requestEconomicGroupQuotation",
      "requestInsuredQuotation",
      "requestNumberQuotation",
      "requestTakerQuotation",
      "requestSelectFilterQuotation",
      "requestInsuranceCompanyQuotation",
      "requestModalityQuotation",
      "requestSubModalityQuotation",
      "resetCurrentFilters",
      "requestTypeEndorsementQuotation",
      "requestStatusEndorsementQuotation"
    ]),
    searchInput(value) {
      clearTimeout(this.timeout);
      let vm = this;
      // fazer requisição apenas se tiver valor no input
      if (value.target.value.length >= 3)
        this.timeout = setTimeout(function() {
          const item =
            value.target.id == "filterEndorsement"
              ? 0
              : vm.indexAutocompleteFilter + 1;
          vm.fetchAutocompleteFilter(value.target.value, item);
          vm.timeout = null;
        }, 500);
    },
    fetchAutocompleteFilter(value, index = null) {
      const payload = `?query=${value}`;
      this.withLoading(this[MOCK_REQUEST_AUTOCOMPLETE_FILTER[index]](payload));
    },
    fetchSelectFilter(index, type) {
      this.withLoading(this[MOCK_REQUEST_SELECT_FILTER[index]](type));
    },
    getFilterPayload(currentFilter) {
      // O usuário só pode escolher apenas um tipo de filtro
      // Conforme for a escolha do filtro, vai alterar o payload
      const filterChosen =
        currentFilter.tipo.id == null
          ? ""
          : currentFilter.tipo.id == "numero_solicitacao"
          ? `&${currentFilter.tipo.id}=${currentFilter.valor.numero}`
          : currentFilter.tipo.id == "data_inicio_vigencia" ||
            currentFilter.tipo.id == "data_fim_vigencia"
          ? this.payloadDateFilterPolicy(currentFilter)
          : currentFilter.tipo.id == "tribunal_id" ||
            currentFilter.tipo.id == "grupo_economico_id"
          ? `&${currentFilter.tipo.id}=${currentFilter.valor.id}`
          : currentFilter.tipo.id == "segurado_id"
          ? `&${currentFilter.tipo.id}=${currentFilter.valor.segurado.id}`
          : `&${currentFilter.tipo.id}=${currentFilter.valor}`;
          let payload = `${this.payloadTakerFilterPolicy(currentFilter)}&vigente=${currentFilter.vigente}&nao_vigente=${currentFilter.nao_vigente}${filterChosen}`;
          if (currentFilter.situacao != null) {
            payload += "&situacao=" + currentFilter.situacao; 
          }
          return payload;
    },
    payloadTakerFilterPolicy(currentFilter) {
      return currentFilter.filter?.id
        ? `&tomador_id=${currentFilter.filter.id}`
        : currentFilter.filter
        ? `&query=${currentFilter.filter}`
        : "";
    },
    payloadDateFilterPolicy(currentFilter) {
      const inicio = `&${currentFilter.tipo.id}_de=${new Date(
        currentFilter.inicio
      ).toISOString()}`;
      const fim = `&${currentFilter.tipo.id}_ate=${new Date(
        currentFilter.fim
      ).toISOString()}`;
      return `${inicio}${fim}`;
    },
    getPayload(options, currentFilter) {
      const { page, itemsPerPage, sortDesc, sortBy } = options;
      const directSort =
        sortBy.length == 1 ? (sortDesc[0] ? "desc" : "asc") : "desc";
      // Pegar do headers o elemento que será ordenado
      const sort = sortBy.length == 1 ? sortBy[0] : "";
      return `?page=${page}&page_size=${itemsPerPage}&sort=${sort}&direction=${directSort}${this.getFilterPayload(
        currentFilter
      )}`;
    }
  }
};
